module.exports = __webpack_public_path__ + "static/media/Outsider.67a421a6.jpeg";